import { z } from 'zod';
import { endpoint } from './endpoint.js';
import {
  ClientIdSchema,
  ClientSchema,
  CreateClientSchema,
  ListClientsQuerySchema,
  UpdateClientSchema,
} from '../schemas/client.js';

export const clients = {
  list: endpoint('GET', '/clients', ListClientsQuerySchema, z.array(ClientSchema)),
  getById: endpoint('GET', '/clients/:id', z.object({ id: ClientIdSchema }), ClientSchema),
  create: endpoint('POST', '/clients', CreateClientSchema, ClientSchema),
  update: endpoint(
    'PATCH',
    '/clients/:id',
    z.object({ id: ClientIdSchema }).merge(UpdateClientSchema),
    ClientSchema,
  ),
  delete: endpoint('DELETE', '/clients/:id', z.object({ id: ClientIdSchema }), ClientSchema),
};
